import { Box, Table } from "@chakra-ui/react";

import { Pagination } from "components/Pagination";

import { TableBody } from "./TableBody";
import {AppointmentTableBorder} from "../../components/AppointmentTableBorder";
import {AppointmentsTableHeader} from "../../components/AppointmentsTableHeader";

interface IProps {
  totalAppointments: number;
  limit: number;
}

const AppointmentsTable = ({ totalAppointments, limit }: IProps) => {
  return (
    <AppointmentTableBorder>
      <Table variant="simple">
        <AppointmentsTableHeader />
        <TableBody limit={limit} />
      </Table>
      <Box mt={4}>
        <Pagination total={totalAppointments} limit={limit} />
      </Box>
    </AppointmentTableBorder>
  );
};

export { AppointmentsTable };
